var map = {
	"./community-category/index.sync.tsx": 879,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 880,
	"./header-navigation/index.sync.tsx": 912,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 929,
	"./knowledge-base/index.sync.tsx": 932,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 949,
	"./site-wide/index.sync.tsx": 969,
	"./topic-banner/TopicBanner.sync.tsx": 1009,
	"./widget-custom-html/index.sync.tsx": 1022,
	"./widget-featured-topics/index.sync.tsx": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1394;